<template>

  <modal-layout
    :bgShow="modalImage.bg"
    :modalShow="modalImage.modal"
    @close="close">

    <div
      class="image-modal" @click.prevent="close()">
      <div
        class="image-modal__head">
        <div>
          {{ modalImage.title }}
          
        </div>
        <a
          href="/close"
          @click.prevent="close()"
          class="close">
          <img
            src="@/../static/img/icons/close.svg">
        </a>
      </div>
      <div
        class="image-modal__body">
        <img
          :src="modalImage.image">
        <div
          v-if="modalImage.description"
          class="description"
          v-html="formattedDescription"></div>
        <span class="hint">Для удобства просмотра переверните устройство в горизонтальное положение</span>
      </div>
     
    </div>

  </modal-layout>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import ModalLayout from './ModalLayout';

export default {
  components: {
    ModalLayout,
  },
  computed: {
    ...mapState('layout', ['modalImage']),
    formattedDescription() {
      return String(this.modalImage.description || '').replace(/<\/br\s*>/gi, '<br>');
    },
  },
  methods: {
    ...mapMutations('layout', ['SET_MODAL_IMAGE']),

    close() {
      this.SET_MODAL_IMAGE({
        modal: false,
        bg: false,
        title: '',
        image: '',
        description: '',
      });
    },
  },
}
</script>

<style lang="sass">
  @import '@/styles/components/modals/image-modal.sass'
</style>
